import { useMemo } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { BootstrapTable } from '@components/Table';

const renderBelowThresholdCell = ({ value }) => {
  if (!value) {
    return 'Balance is above the threshold.';
  }
  return (
    <Row>
      <Col md={4}>
        <span className="textRed">Balance below threshold</span>
      </Col>
      <Col className="text-start">
        <Button variant="didxl" size="sm" as={Link} to="/billing/balance">
          Top-up
        </Button>
      </Col>
    </Row>
  );
};

export const BalanceThresholdTable = ({ data }) => {
  const columns = useMemo(() => [
    {
      accessor: 'date',
      className: 'col-md-2',
    },
    {
      accessor: 'belowThreshold',
      className: 'col-md-10',
      Cell: renderBelowThresholdCell,
    },
  ]);

  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ borderless: true })}
      hideHeader
    />
  );
};
